/* Imports needed for all question form subclasses. */
import * as React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
    QuestionFormBase,
    QuestionFormBaseProps,
    QuestionFormBaseState,
    mapStateToQuestionFormBaseProps,
    mapDispatchToQuestionFormBaseProps
} from '../../QuestionFormBase';
import { MULTIMEDIA_TYPES, QTYPES, Question } from '@nexxt/common/types';
import { STATIC_STORAGE_URL } from '@nexxt/common/constants';
import classnames from 'classnames';
import * as _ from 'lodash';
import NotifyHOC from '../../../../../../HOC/Notifications';

/* Components used in this question form. */
import Toggle from '../../../../../common/Toggle';
import BuilderHeader from '../../../common/builderHeader';
import QuestionSettings from '../../../common/questionSettings';
import { Notes, WarnNotes } from '../../../../../common/notes';

import './_guidedFantasy.scss';
import { generateCombinedImages } from '../../../../../../services/question.service';
import MultimediaBubble from '../../../common/MultimediaBubble';
import MediaManager from '../../../../../libraries/mediaLibrary/MediaManager';
import Loader from '../../../../../common/Loader/Loader';
import { ALERT_MESSAGE_TYPES } from '../../../../../../interface/project.interface';

interface GuidedFantasyProps extends QuestionFormBaseProps {
    // nothing special... yet!
}

interface GuidedFantasyState extends QuestionFormBaseState {
    // nothing special... yet!
    isRequesting: boolean;
}

const BLACK_FLAG_IMAGE_URL =
    STATIC_STORAGE_URL +
    '/img/portal/projectiveTechniques/guided-fantasy/Template_Guided_Fantasy_1_Black.png';
const WHITE_FLAG_IMAGE_URL =
    STATIC_STORAGE_URL +
    '/img/portal/projectiveTechniques/guided-fantasy/Template_Guided_Fantasy_1.png';
class GuidedFantasy extends QuestionFormBase<
    GuidedFantasyProps,
    GuidedFantasyState
> {
    constructor(p: QuestionFormBaseProps) {
        super(p, QTYPES.GUIDED_FANTASY);
        // set value from question here
        const question = {
            ...this.state.question,
            showAlternateWording: true,
            guidedFantasySettings: {
                ...this.state.question.guidedFantasySettings
            }
        };
        this.state = {
            ...this.state,
            isRequesting: false,
            question
        };
    }

    generateGIFs = async (logoURL: string) => {
        const response = await generateCombinedImages(logoURL);

        this.setState(
            (prevState) => ({
                isRequesting: false,
                question: {
                    ...prevState.question,
                    guidedFantasySettings: {
                        ...prevState.question.guidedFantasySettings,
                        ...response
                    }
                }
            }),
            this.setEditFlag
        );
    };

    selectMedia = (selectedMedia: any) => {
        this.setState(
            (prevState) => ({
                question: {
                    ...(prevState.question as Question),
                    mediaURL: selectedMedia.mediaURL,
                    videoURL: null,
                    embeddedURL: null
                },
                isMediaLibraryOpen: false,
                mediaType: null,
                questionError: {
                    ...(this.state.questionError as any),
                    mediaURL: null
                },
                isRequesting: true
            }),
            async () => {
                this.setEditFlag;
                await this.generateGIFs(selectedMedia.mediaURL);
            }
        );
    };

    toggleBlackFlag = () => {
        this.setState(
            (prevState) => ({
                ...prevState,
                question: {
                    ...prevState.question,
                    guidedFantasySettings: {
                        ...prevState.question.guidedFantasySettings,
                        useBlackFlag:
                            !prevState.question?.guidedFantasySettings
                                ?.useBlackFlag
                    }
                }
            }),
            this.setEditFlag
        );
    };

    clearLogoImage = () => {
        this.setState(
            {
                ...this.state,
                question: {
                    ...this.state.question,
                    mediaURL: null
                }
            },
            this.setEditFlag
        );
    };
    render() {
        const { currentProject } = this.props;
        const {
            isSettingBoxLayoutOpen,
            question,
            isMediaLibraryOpen,
            isRequesting
        } = this.state;
        const { guidedFantasySettings } = question;
        const questionError =
            (this.state.showError && this.state.questionError) || {};
        const flagImageURL = this.state.question?.guidedFantasySettings
            ?.useBlackFlag
            ? BLACK_FLAG_IMAGE_URL
            : WHITE_FLAG_IMAGE_URL;
        const bgKey = this.state.question?.guidedFantasySettings?.useBlackFlag
            ? 'black_images'
            : 'white_images';
        return (
            <div>
                {isRequesting ? <Loader isInline={false} /> : null}
                <div className="project-add--question-builder">
                    <BuilderHeader
                        toggleSettingBoxLayout={this.toggleSettingBoxLayout}
                        isSettingBoxLayoutOpen={isSettingBoxLayoutOpen}
                        showAlert={!this.props.editEnabled}
                        alertMessages={this.getWarningMessage()}
                        question={question}
                        setValue={this.setQuestion}
                        disabled={!this.props.editEnabled}
                        errorObject={this.state.questionError}
                    />
                    <div className="builder-body">
                        {(isSettingBoxLayoutOpen && (
                            <QuestionSettings
                                onClose={this.toggleSettingBoxLayout}
                                question={question}
                                questionSettings={{
                                    allowUserEdit: true,
                                    showGenericProbe: true
                                }}
                                setValue={this.setQuestion}
                                disabled={!this.props.editEnabled}
                            />
                        )) ||
                            null}
                        {this.renderErrorNotes()}
                        {/* <MultimediaBubble
                            question={question}
                            languages={currentProject.languages}
                            setValue={this.setQuestion}
                            setValueWithLanguage={
                                this.NEW_setQuestionTextTranslation
                            }
                            addNewBubble={this.NEW_addNewEditor}
                            removeBubble={this.NEW_removeEditor}
                            disabled={!this.props.editEnabled}
                            questionError={questionError}
                            settings={{ showClose: true }}
                        /> */}
                        <Notes note="This question type has a pre-written question structure. You are not able to customize the question wording." />
                        <MultimediaBubble
                            question={question}
                            languages={currentProject.languages}
                            setValue={this.setQuestion}
                            setValueWithLanguage={
                                this.NEW_setQuestionTextTranslation
                            }
                            questionText={'Brand Name'}
                            settings={{ showTextarea: false, noBorder: true }}
                            disabled={!this.props.editEnabled}
                            questionError={questionError}
                            defaultTextType={MULTIMEDIA_TYPES.TEXT}
                            keyName="alternateWordingTexts"
                            disableAddBubble
                        />
                        <div className="row">
                            <div
                                className={classnames('col-md-4 form-group', {
                                    error:
                                        questionError && questionError.mediaURL
                                })}
                            >
                                <label className="form-group-header">
                                    Upload Logo
                                </label>
                                {question.mediaURL &&
                                    guidedFantasySettings.hasOwnProperty(
                                        bgKey
                                    ) &&
                                    !guidedFantasySettings?.has_transparent && (
                                        <Notes
                                            type={ALERT_MESSAGE_TYPES.WARN}
                                            note="Your image is not transparent. If you're happy with how it looks in the preview, you can ignore this warning"
                                        />
                                    )}
                                {question.mediaURL &&
                                    guidedFantasySettings.hasOwnProperty(
                                        bgKey
                                    ) &&
                                    !guidedFantasySettings?.is_small && (
                                        <Notes
                                            type={ALERT_MESSAGE_TYPES.WARN}
                                            note="Your image is smaller than the recommended size. If you're happy with how it looks in the preview, you can ignore this warning"
                                        />
                                    )}
                                <Notes
                                    note="For best results, use a transparent logo.
                                Recommended image size: 320*200px. Accepted image types: PNG"
                                />
                                <div
                                    className="row"
                                    style={{ justifyContent: 'space-around' }}
                                >
                                    <label className="form-group-header">
                                        Use black flag{' '}
                                    </label>
                                    <Toggle
                                        onChange={this.toggleBlackFlag}
                                        checked={
                                            question.guidedFantasySettings
                                                ?.useBlackFlag
                                        }
                                        disabled={!this.props.editEnabled}
                                    />
                                </div>
                            </div>
                            <div className={classnames('col-md-8 form-group')}>
                                <div className="guided-fantasy-image--container">
                                    <div className="guided-fantasy-image--wrapper">
                                        <img
                                            src={
                                                question.mediaURL &&
                                                !isRequesting
                                                    ? guidedFantasySettings?.[
                                                          bgKey
                                                      ]?.static_preview_url
                                                    : flagImageURL
                                            }
                                        />
                                        <MediaManager
                                            showMediaManager={
                                                isMediaLibraryOpen
                                            }
                                            toggleMediaManager={(toggle) =>
                                                this.setState({
                                                    isMediaLibraryOpen: toggle
                                                })
                                            }
                                            applyCurrentMedia={this.selectMedia}
                                            type="image"
                                            showMediaLibrary
                                        >
                                            <div
                                                className={classnames(
                                                    'logo--placeholder',
                                                    {
                                                        'after-uploads':
                                                            !isRequesting &&
                                                            question.mediaURL
                                                    }
                                                )}
                                            >
                                                {!isRequesting &&
                                                question.mediaURL ? (
                                                    <>
                                                        <span
                                                            className="nx-option-edit icon-lg"
                                                            onClick={
                                                                this
                                                                    .clearLogoImage
                                                            }
                                                        >
                                                            <i className="nx nx-close" />
                                                        </span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <span
                                                            style={{
                                                                cursor: 'pointer'
                                                            }}
                                                            className={`nx-option-edit icon-lg`}
                                                            onClick={this.toggleMediaLibrary(
                                                                'image'
                                                            )}
                                                        >
                                                            <i className="nx nx-edit"></i>{' '}
                                                        </span>

                                                        <span>
                                                            your logo here
                                                        </span>
                                                    </>
                                                )}
                                            </div>
                                        </MediaManager>
                                    </div>
                                </div>
                                {questionError && questionError.mediaURL ? (
                                    <span className="form-group__error-msg">
                                        {questionError.mediaURL}
                                    </span>
                                ) : null}
                            </div>
                        </div>
                        <div className="row">
                            <div
                                className={classnames('col-md-6 form-group', {
                                    error: questionError && questionError.max
                                })}
                            >
                                <label className="form-group-header">
                                    Maximum number of follow up questions
                                </label>
                                <input
                                    type="number"
                                    className="form-group__control"
                                    placeholder="Please add the maximum number of follow up questions"
                                    disabled={!this.props.editEnabled}
                                    onChange={(
                                        event: React.ChangeEvent<HTMLInputElement>
                                    ) =>
                                        this.setQuestion(
                                            'max',
                                            event.target.value
                                        )
                                    }
                                    value={question.max}
                                />
                                {questionError && questionError.max ? (
                                    <span className="form-group__error-msg">
                                        {questionError.max}
                                    </span>
                                ) : null}
                            </div>
                        </div>
                        <Notes
                            type={ALERT_MESSAGE_TYPES.WARN}
                            note="This question type currently is only available for data export on dashboard"
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(
    NotifyHOC(
        connect(
            mapStateToQuestionFormBaseProps,
            mapDispatchToQuestionFormBaseProps
        )(GuidedFantasy)
    )
);
